var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-form',{on:{"submit":function($event){$event.preventDefault();}}},[_c('pictos-form',{attrs:{"doc":_vm.doc},on:{"update":_vm.update}}),_c('v-btn',{staticClass:"mt-5",on:{"click":_vm.onSubmit}},[_vm._v("Submit")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }